module.exports = __webpack_public_path__ + "static/media/Lyght_circle.2c354e41.svg";